import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { StorageLayout } from "../StorageLayout";
import { StorageEntities } from "../StorageEntities";
import { StorageRouterProps } from "../StorageRouterProps";
import AssignmentsTable from "../components/AssignmentsTable";
import StorageConnect from "../components/StorageConnect";

export interface StorageListPageProps extends NSARouterMakerResult, StorageRouterProps { }

class StorageListPage extends Component<StorageListPageProps>
{
    override render()
    {
        return (
            <StorageLayout
                {...this.props}
                pages={{
                    entity: StorageEntities.storage(this.props),
                    list: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Assignment",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <AssignmentsTable
                                                            {...this.props}
                                                            storage_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                            {
                                                title: "Connection",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <StorageConnect
                                                            {...this.props}
                                                            storage_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                    }
                }}
            >
                <></>
            </StorageLayout>
        );
    }
}

export default StorageListPage;